'use strict';

var os = require('os');
if (typeof os.homedir !== 'undefined') {
  module.exports = os.homedir;
} else {
  module.exports = require('./polyfill.js');
}




//////////////////
// WEBPACK FOOTER
// ./~/homedir-polyfill/index.js
// module id = 1442
// module chunks = 0 1